import { render, staticRenderFns } from "./ResponsiveImage.vue?vue&type=template&id=63a10037&"
import script from "./ResponsiveImage.ts?vue&type=script&lang=ts&"
export * from "./ResponsiveImage.ts?vue&type=script&lang=ts&"
import style0 from "./ResponsiveImage.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports